module.exports = __webpack_public_path__ + "static/cetmen-sm-f0f38ae987f62d925d4520f561c45465.jpg";